import { Typography } from 'antd';
import type { BaseType } from 'antd/lib/typography/Base';
import { ErrorMessage } from 'formik';

import './ValidationError.scss';

import { cNs } from 'src/helpers';

function toErrorMessage(errorMessage: object): string {
  return Object.entries(errorMessage)
    .map(([key, value]) => `${key}: ${value}`)
    .join(', ');
}

type ValidationErrorProps = {
  name: string;
  errorType?: BaseType;

  className?: string;
};

export function ValidationError({ name, errorType = 'danger', className }: Readonly<ValidationErrorProps>) {
  return (
    <Typography.Text className={cNs('validation-error__container', className)} type={errorType}>
      <ErrorMessage
        name={name}
        render={(errorMessage) => (typeof errorMessage === 'object' ? toErrorMessage(errorMessage) : errorMessage)}
      />
    </Typography.Text>
  );
}
